const CartStatus = {
  OPEN: 'open',
  QUOTE: 'quote',
  PROCESSING: 'processing',
  FINISHED: 'finished',
  CANCELED: 'canceled',
  DISCARDED: 'discarded',
}

export default CartStatus
